<a [routerLink]="specialNavItem.href" (click)="onClickLoginLink(specialNavItem.ymGoal)" class="prf-header-login-link">
  <span aria-hidden="true" class="prf-header-login-icon"></span>
  {{ specialNavItem.linkText }}
</a>
